// @ts-nocheck
import copy from 'utils/cloneObj';
import { numberFormat } from 'utils/format';
import {
  ADD_CLAIM_ATTACHMENT_REQUEST,
  ADD_CLAIM_ATTACHMENT_SUCCESS,
  ADD_CLAIM_NOTE_REQUEST,
  ADD_CLAIM_NOTE_SUCCESS,
  ADD_CLAIM_REASON_REQUEST,
  ADD_CLAIM_REASON_SUCCESS,
  CLEAR_REDUCER,
  DELETE_CLAIM_ATTACHMENT_REQUEST,
  DELETE_CLAIM_ATTACHMENT_SUCCESS,
  DELETE_CLAIM_NOTE_REQUEST,
  DELETE_CLAIM_NOTE_SUCCESS,
  GET_CLAIM_ATTACHMENT_REQUEST,
  GET_CLAIM_ATTACHMENT_SUCCESS,
  GET_CLAIM_DETAILS_REQUEST,
  GET_CLAIM_DETAILS_SUCCESS,
  GET_CLAIM_HISTORY_REQUEST,
  GET_CLAIM_HISTORY_SUCCESS,
  GET_CLAIM_LIST_REQUEST,
  GET_CLAIM_LIST_SUCCESS,
  GET_CLAIM_REQUEST,
  GET_CLAIM_SUCCESS,
  GET_CLAIM_SUMMARY_REQUEST,
  GET_CLAIM_SUMMARY_SUCCESS,
  GET_CLAIM_TASK_LIST_REQUEST,
  GET_CLAIM_TASK_LIST_SUCCESS,
  GET_HIDE_TASK_FAILURE,
  GET_HIDE_TASK_REQUEST,
  GET_HIDE_TASK_SUCCESS,
  POST_CLAIM_REQUEST,
  POST_CLAIM_SUCCESS,
  POST_HIDE_TASK_FAILURE,
  POST_HIDE_TASK_REQUEST,
  POST_HIDE_TASK_SUCCESS,
  RESET_CLAIM_ATTACHMENTS,
  RESET_UPDATED_CLAIM_TASKS,
  UPDATE_CLAIM_ATTACHMENT_REQUEST,
  UPDATE_CLAIM_ATTACHMENT_SUCCESS,
  UPDATE_CLAIM_NOTE_REQUEST,
  UPDATE_CLAIM_NOTE_SUCCESS,
  UPDATE_SUBTASK_CLAIM_PROGRESS,
  DELETE_CLAIM_REQUEST,
  DELETE_CLAIM_SUCCESS,
} from '../constants/claimConstants';

const initialState = {
  claim: {},
  claims: [],
  clientDetails: {},
  claimHistory: {},
  claimHistorySummary: {},
  claimDeletable: false,
  claimSummary: {},
  claimTasks: [],
  updatedClaimTasks: [],
  updatedClaimTasksAfterSubmission: [],
  claimAttachments: [],
  postClaimSuccess: false,
  claimLoader: false,
  claimTaskLoader: false,
  claimSummaryLoader: false,
  addClaimNoteSuccess: false,
  deleteClaimNoteSuccess: false,
  updateClaimNoteSuccess: false,
  addClaimReasonSuccess: false,
  addClaimAttachmentSuccess: false,
  updateClaimAttachmentSuccess: false,
  deleteClaimAttachmentSuccess: false,
  hideTaskRequesting: false,
  hideTaskResponse: null,
  hideTaskError: null,
  postHideTaskRequesting: false,
  postHideTaskResponse: null,
  postHideTaskError: null,
  taskStatus: {
    id: '',
    checked: false,
  },
  deleteClaimSuccess: false,
};

function claimReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CLAIM_LIST_REQUEST:
      return {
        ...state,
        claimLoader: true,
      };
    case GET_HIDE_TASK_REQUEST:
      return {
        ...state,
        hideTaskRequesting: true,
        hideTaskResponse: null,
        hideTaskError: null,
      };
    case GET_HIDE_TASK_SUCCESS:
      return {
        ...state,
        hideTaskRequesting: false,
        hideTaskResponse: action?.payload,
        hideTaskError: null,
      };
    case GET_HIDE_TASK_FAILURE:
      return {
        ...state,
        hideTaskRequesting: false,
        hideTaskResponse: null,
        hideTaskError: action?.payload,
      };
    case POST_HIDE_TASK_REQUEST:
      return {
        ...state,
        postHideTaskRequesting: true,
        postHideTaskResponse: null,
        postHideTaskError: null,
      };
    case POST_HIDE_TASK_SUCCESS:
      return {
        ...state,
        postHideTaskRequesting: false,
        postHideTaskResponse: action?.payload,
        postHideTaskError: null,
      };
    case POST_HIDE_TASK_FAILURE:
      return {
        ...state,
        postHideTaskRequesting: false,
        postHideTaskResponse: null,
        postHideTaskError: action?.payload,
      };

    case GET_CLAIM_LIST_SUCCESS:
      return {
        ...state,
        claims: action.payload.claims,
        clientDetails: action.payload.client_details,
        claimLoader: false,
      };

    case GET_CLAIM_TASK_LIST_REQUEST:
      return {
        ...state,
        claimTaskLoader: true,
      };

    case GET_CLAIM_TASK_LIST_SUCCESS:
      return {
        ...state,
        claimTasks: action.payload.data,

        claimTaskLoader: false,
      };

    case GET_CLAIM_REQUEST:
      return {
        ...state,
        claimTaskLoader: true,
      };

    case GET_CLAIM_SUCCESS:
      const { claims, ...restData } = action.payload;
      return {
        ...state,
        claimTaskLoader: false,
        claim: restData,
        updatedClaimTasks: claims,
      };

    case GET_CLAIM_DETAILS_REQUEST:
      return {
        ...state,
        claimTaskLoader: true,
      };

    case GET_CLAIM_DETAILS_SUCCESS:
      return {
        ...state,
        claimTaskLoader: false,
        claimTasks: action.payload.claim_details,
        claimHistory: action.payload.claim_history,
        claimHistorySummary: action.payload.claim_summary,
        claimDeletable: action.payload.deletable,
      };

    case GET_CLAIM_HISTORY_REQUEST:
      return {
        ...state,
        claimLoader: true,
      };

    case GET_CLAIM_HISTORY_SUCCESS:
      return {
        ...state,
        claimHistory: action.payload.claim_history,
        claimLoader: false,
      };

    case GET_CLAIM_SUMMARY_REQUEST:
      return {
        ...state,
        claimSummaryLoader: true,
      };

    case GET_CLAIM_SUMMARY_SUCCESS:
      return {
        ...state,
        claimSummary: action.payload.claim_summary,
        claimSummaryLoader: false,
      };

    case UPDATE_SUBTASK_CLAIM_PROGRESS:
      return updateSubTaskClaimProgress(state, action);

    case POST_CLAIM_REQUEST:
      return {
        ...state,
        postClaimSuccess: false,
      };

    case POST_CLAIM_SUCCESS:
      return {
        ...state,
        postClaimSuccess: true,
        updatedClaimTasks: [],
        claim: {},
      };

    case RESET_UPDATED_CLAIM_TASKS:
      return {
        ...state,
        updatedClaimTasks: [],
        updatedClaimTasksAfterSubmission: [],
      };

    case ADD_CLAIM_NOTE_REQUEST:
      return {
        ...state,
        addClaimNoteSuccess: false,
      };

    case ADD_CLAIM_NOTE_SUCCESS:
      return addClaimNote(state, action);

    case DELETE_CLAIM_NOTE_REQUEST:
      return {
        ...state,
        deleteClaimNoteSuccess: false,
      };

    case DELETE_CLAIM_NOTE_SUCCESS:
      return deleteClaimNote(state, action);

    case UPDATE_CLAIM_NOTE_REQUEST:
      return {
        ...state,
        updateClaimNoteSuccess: false,
      };

    case UPDATE_CLAIM_NOTE_SUCCESS:
      return updateClaimNote(state, action);

    case ADD_CLAIM_REASON_REQUEST:
      return {
        ...state,
        addClaimReasonSuccess: false,
      };

    case ADD_CLAIM_REASON_SUCCESS:
      return updateTaskReasonAdjustment(state, action);

    case GET_CLAIM_ATTACHMENT_REQUEST:
      return {
        ...state,
        getClaimAttachmentSuccess: false,
      };

    case GET_CLAIM_ATTACHMENT_SUCCESS:
      return {
        ...state,
        getClaimAttachmentSuccess: true,
        claimAttachments: action.payload,
      };

    case ADD_CLAIM_ATTACHMENT_REQUEST:
      return {
        ...state,
        addClaimAttachmentSuccess: false,
      };

    case ADD_CLAIM_ATTACHMENT_SUCCESS:
      return {
        ...state,
        addClaimAttachmentSuccess: true,
        claimAttachments: [...state.claimAttachments, action.payload],
      };

    case UPDATE_CLAIM_ATTACHMENT_REQUEST:
      return {
        ...state,
        updateClaimAttachmentSuccess: false,
      };

    case UPDATE_CLAIM_ATTACHMENT_SUCCESS:
      return {
        ...state,
        updateClaimAttachmentSuccess: true,
        claimAttachments: [
          ...state.claimAttachments.filter(
            (claimAttachment) => claimAttachment.id !== action.payload.id,
          ),
          action.payload,
        ],
      };

    case DELETE_CLAIM_ATTACHMENT_REQUEST:
      return {
        ...state,
        deleteClaimAttachmentSuccess: false,
      };

    case DELETE_CLAIM_ATTACHMENT_SUCCESS:
      return {
        ...state,
        deleteClaimAttachmentSuccess: true,
        claimAttachments: state.claimAttachments.filter(
          (claimAttachment) => claimAttachment.id !== action.payload,
        ),
      };

    case RESET_CLAIM_ATTACHMENTS:
      return {
        ...state,
        claimAttachments: [],
      };

    case DELETE_CLAIM_REQUEST:
      return {
        ...state,
        deleteClaimSuccess: false,
      };

    case DELETE_CLAIM_SUCCESS:
      return {
        ...state,
        deleteClaimSuccess: true,
      };

    case CLEAR_REDUCER:
      return {
        claim: {},
        claims: [],
        clientDetails: {},
        claimHistory: {},
        claimHistorySummary: {},
        claimDeletable: false,
        claimSummary: {},
        claimTasks: [],
        updatedClaimTasks: [],
        updatedClaimTasksAfterSubmission: [],
        claimAttachments: [],
        postClaimSuccess: false,
        claimLoader: false,
        claimTaskLoader: false,
        claimSummaryLoader: false,
        addClaimNoteSuccess: false,
        deleteClaimNoteSuccess: false,
        updateClaimNoteSuccess: false,
        addClaimReasonSuccess: false,
        addClaimAttachmentSuccess: false,
        updateClaimAttachmentSuccess: false,
        deleteClaimAttachmentSuccess: false,
        hideTaskRequesting: false,
        hideTaskResponse: null,
        hideTaskError: null,
        postHideTaskRequesting: false,
        postHideTaskResponse: null,
        postHideTaskError: null,
        taskStatus: {
          id: '',
          checked: false,
        },
        deleteClaimSuccess: false,
      };

    default: {
      return state;
    }
  }
}

const addClaimNote = (state, action) => {
  const clonedClaimTasks = copy(state.claimTasks);
  const selectedTask = clonedClaimTasks.find(
    (claimTask) => claimTask.id === action.payload.task_id,
  );
  if (selectedTask) {
    const selectedSubTask = selectedTask.sub_task.find(
      (subTask) => subTask.id === action.payload.sub_task_id,
    );
    if (selectedSubTask) {
      selectedSubTask.notes.push(action.payload);
    }
  }

  return {
    ...state,
    claimTasks: clonedClaimTasks,

    addClaimNoteSuccess: true,
  };
};

const updateClaimNote = (state, action) => {
  const clonedClaimTasks = copy(state.claimTasks);
  const selectedTask = clonedClaimTasks.find(
    (claimTask) => claimTask.id === action.payload.task_id,
  );
  if (selectedTask) {
    const selectedSubTask = selectedTask.sub_task.find(
      (subTask) => subTask.id === action.payload.sub_task_id,
    );
    if (selectedSubTask) {
      selectedSubTask.notes = selectedSubTask.notes
        .filter((note) => note.id !== action.payload.id)
        .concat(action.payload);
    }
  }

  return {
    ...state,
    claimTasks: clonedClaimTasks,
    updateClaimNoteSuccess: true,
  };
};

const deleteClaimNote = (state, action) => {
  const clonedClaimTasks = copy(state.claimTasks);
  const selectedTask = clonedClaimTasks.find(
    (claimTask) => claimTask.id === action.payload.task_id,
  );
  if (selectedTask) {
    const selectedSubTask = selectedTask.sub_task.find(
      (subTask) => subTask.id === action.payload.sub_task_id,
    );
    if (selectedSubTask) {
      selectedSubTask.notes = selectedSubTask.notes.filter(
        (note) => note.id !== action.payload.note_id,
      );
    }
  }

  return {
    ...state,
    claimTasks: clonedClaimTasks,
    deleteClaimNoteSuccess: true,
  };
};

const updateTaskReasonAdjustment = (state, action) => {
  const clonedClaimTasks = copy(state.claimTasks);
  const selectedTask = clonedClaimTasks.find(
    (claimTask) => claimTask.id === action.payload.task_id,
  );
  if (selectedTask) {
    const selectedSubTask = selectedTask.sub_task.find(
      (subTask) => subTask.id === action.payload.sub_task_id,
    );
    if (selectedSubTask) {
      const { task, task_id, sub_task_id, ...rest } = action.payload;
      selectedSubTask.reason = rest;
      selectedSubTask.need_to_add_adjustment_reason = false;
    }
  }

  return {
    ...state,
    claimTasks: clonedClaimTasks,
    addClaimReasonSuccess: true,
  };
};

const updateSubTaskClaimProgress = (state, action) => {
  const clonedClaimTasks = copy(state.claimTasks);
  const clonedUpdatedClaimTasks = [...state.updatedClaimTasks];
  let clonedUpdatedClaimTasksAfterSubmission = [
    ...state.updatedClaimTasksAfterSubmission,
  ];

  clonedClaimTasks.forEach((task) => {
    if (task.id === action.payload.taskId) {
      task.sub_task.forEach((subTask) => {
        if (subTask.id === action.payload.subTaskId) {
          if (!subTask.initial_percentage) {
            subTask.initial_percentage = subTask.percentage;
          }

          subTask.percentage = +action.payload.value;

          if (
            action.payload.hasCompletedChangingPercentage &&
            subTask.percentage < subTask.previous_approved_percentage
          ) {
            subTask.percentage = subTask.previous_approved_percentage;
          }

          subTask.current_claim = numberFormat(
            ((subTask.percentage - subTask.previous_approved_percentage) /
              100) *
              subTask.contract_sum,
          );

          const previouslyClaimedTask = clonedUpdatedClaimTasks.find(
            (claimTask) => claimTask.sub_task_id === subTask.sub_task_id,
          );

          if (previouslyClaimedTask) {
            previouslyClaimedTask.percentage = subTask.percentage;
            previouslyClaimedTask.current_claim =
              ((previouslyClaimedTask.percentage -
                previouslyClaimedTask.previous_approved_percentage) /
                100) *
              previouslyClaimedTask.contract_sum;

            if (+previouslyClaimedTask.percentage === 0) {
              const index = clonedUpdatedClaimTasks.findIndex(
                (claimTask) => claimTask.sub_task_id === subTask.sub_task_id,
              );

              clonedUpdatedClaimTasks.splice(index, 1);
            }
          } else if (+subTask.percentage > 0) {
            clonedUpdatedClaimTasks.push({
              sub_task_id: subTask.sub_task_id,
              task_id: subTask.task_id,
              title: subTask.title,
              is_variation: action.payload.taskType === 'Variation',
              percentage: subTask.percentage,
              previous_approved_percentage:
                subTask.previous_approved_percentage,
              task: subTask.sub_task_id,
              contract_sum: subTask.contract_sum,
              previous_approved: subTask.previous_approved,
              current_claim:
                ((subTask.percentage - subTask.previous_approved_percentage) /
                  100) *
                subTask.contract_sum,
            });
          }

          if (action.payload.mode === 'edit' && subTask.percentage !== 100) {
            subTask.need_to_add_adjustment_reason =
              subTask.percentage !== subTask.initial_percentage;

            if (
              clonedUpdatedClaimTasksAfterSubmission.find(
                (claimTask) => claimTask.sub_task_id === subTask.sub_task_id,
              )
            ) {
              clonedUpdatedClaimTasksAfterSubmission =
                clonedUpdatedClaimTasksAfterSubmission.filter(
                  (claimTask) => claimTask.sub_task_id !== subTask.sub_task_id,
                );
            }

            if (subTask.percentage !== subTask.previous_approved_percentage) {
              clonedUpdatedClaimTasksAfterSubmission.push({
                sub_task_id: subTask.sub_task_id,
                task_id: subTask.task_id,
                percentage: subTask.percentage,
                previous_approved_percentage:
                  subTask.previous_approved_percentage,
              });
            }
          }
        }
      });
    }
  });

  return {
    ...state,
    claimTasks: clonedClaimTasks,
    updatedClaimTasks: clonedUpdatedClaimTasks,
    updatedClaimTasksAfterSubmission: clonedUpdatedClaimTasksAfterSubmission,
  };
};

export default claimReducer;
